import { FilterBaseModel } from './filter-base.model';
export class EpicerieInventaireFilterModel extends FilterBaseModel {
    constructor() {
        super(...arguments);
        this.loadingData = true;
    }
}
